module.exports = __webpack_public_path__ + "b30c8f9bcf22566e86fd2986ed062263.svg";